import { Component } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';

@Component({
  selector: 'app-confirmation-modal',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">{{ title }}</h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="onDismiss()">
      </button>
    </div>
    <div class="modal-body">
      <p>{{ message }}</p>
    </div>
    <div class="modal-footer">
      <button type="button" uiButton="neutral" (click)="onCancel()">
        {{ cancelLabel }}
      </button>
      <button type="button" uiButton (click)="onConfirm()">
        {{ confirmLabel }}
      </button>
    </div>
  `,
  standalone: false
})
export class ConfirmationModalComponent {
  message: string = '';
  title = 'Bestätigung';
  confirmLabel = 'JA';
  cancelLabel = 'NEIN';
  /** what closing with the X means: "no" for a plain prompt, "undecided" (null) for a choice */
  dismissResult: boolean | null = false;

  constructor(public modalRef: MdbModalRef<ConfirmationModalComponent>) {}

  onConfirm(): void {
    this.modalRef.close(true);
  }

  onCancel(): void {
    this.modalRef.close(false);
  }

  onDismiss(): void {
    this.modalRef.close(this.dismissResult);
  }
}